import { AiPanel } from "./AiPanel";

export function AI() {
  return <AiPanel />;
}
